var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-modal",
    {
      attrs: { title: "Afhandelingstermijn actie wijzigen" },
      on: { close: _vm.cancel },
    },
    [
      _c(
        "cms-form",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { "submit-button": "Opslaan", submitting: _vm.submitting },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "numeric",
                expression: "'numeric'",
              },
            ],
            attrs: {
              title: "Afhandelingstermijn (dagen)",
              name: "actionDeadline",
              placeholder: _vm.deadlinePlaceholder,
              "data-vv-as": "Afhandelingstermijn",
              error: _vm.error("actionDeadline"),
            },
            model: {
              value: _vm.actionDeadline,
              callback: function ($$v) {
                _vm.actionDeadline = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "actionDeadline",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }